import { logger } from '@/lib/logger';
import { useCallStore } from '@stores/call/callStore';
import { defineStore } from 'pinia';
import { computed, ref, watch } from 'vue';

export const useCallReconnectStore = defineStore('callReconnect', () => {
  const callStore = useCallStore();

  const interval = ref<ReturnType<typeof setInterval>>();
  const reconnectingToPeerJS = ref<boolean>(false);
  const reconnectingToPeers = ref<Set<string>>(new Set());
  // omitting socket.io here, because it has its own reconnection-mechanism

  const reconnecting = computed<boolean>(
    () => reconnectingToPeerJS.value || reconnectingToPeers.value.size > 0,
  );

  watch(reconnecting, (reconnecting) => {
    if (reconnecting) {
      startInterval();
    } else {
      stopInterval();
    }
  });

  const startReconnectingToPeerJS = () => {
    reconnectingToPeerJS.value = true;
  };
  const startReconnectingToPeer = (userId: string) => {
    reconnectingToPeers.value.add(userId);
  };

  const startInterval = () => {
    interval.value = setInterval(intervalRunner, 1000);
  };

  const stopInterval = () => {
    clearInterval(interval.value);
  };

  const intervalRunner = async () => {
    if (callStore.callId === null) {
      reset();
      return;
    }
    logger.info({
      msg: 'reconnecting...',
      reconnectingToPeerJS: reconnectingToPeerJS.value,
      reconnectingToPeers: Array.from(reconnectingToPeers.value),
    });

    if (reconnectingToPeerJS.value) {
      if (callStore.peerJsServer?.disconnected) {
        callStore.peerJsServer?.reconnect();
      }
    }

    if (reconnectingToPeers.value.size > 0) {
      for (const userId of reconnectingToPeers.value) {
        await callStore.connectPeer(userId);
      }
    }
  };

  const reset = () => {
    stopInterval();
    reconnectingToPeerJS.value = false;
    reconnectingToPeers.value.clear();
  };

  return {
    startReconnectingToPeerJS,
    startReconnectingToPeer,
    reconnecting,
    reconnectingToPeerJS,
    reconnectingToPeers,
    reset,
  };
});
